





















































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CouponDetail from "@/components/coupon/CouponDetail.vue";

const couponModule = namespace("coupon");

@Component({
  components: {
    CouponDetail
  }
})
export default class auditCouponList extends Vue {
  @couponModule.State("infoName") infoName!: string;
  @couponModule.State("infoStatus") infoStatus!: number;
  @couponModule.State("infoStatusDesc") infoStatusDesc!: string;
  @couponModule.State("putInShop") putInShop!: string;
  @couponModule.State("infoActivityName") infoActivityName!: string;
  @couponModule.State("infoQuantity") infoQuantity!: number;
  @couponModule.State("infoGetQuantity") infoGetQuantity!: number;
  @couponModule.State("infoEffectiveQuantity") infoEffectiveQuantity!: number;
  @couponModule.State("infoPics") infoPics!: Array<string>;
  private showConfirmProup: Boolean = false; // 审核通过弹出层
  private showRejectProup: Boolean = false; // 审核驳回弹出层
  private message: string = ""; // 驳回理由
  defaultImg = require("@/image/default.png");

  mounted() {
    this.$store.commit("coupon/setCouponId", this.$route.query.id);
    this.$store.dispatch("coupon/getCouponInfo");
  }

  /**
   * 审核：驳回/通过
   */
  async auditRejectAndPass(type: any) {
    if (!this.message && type == 0) {
      return (this as any).$notify({ title: "", message: "请填写驳回原因" });
    }
    const params = {
      couponBatchId: this.$route.query.couponBatchId,
      couponAuditResult: this.message,
      type // 1:审核通过 0:审核驳回
    };
    if (type == 1) {
      delete params.couponAuditResult;
    }
    const { error, success }: any = await this.$store.dispatch(
      "coupon/auditRejectAndPass",
      {
        ...params
      }
    );
    if (success) {
      type == 0
        ? (this.showRejectProup = false)
        : (this.showConfirmProup = false);
      (this as any).$toast({
        type: "success",
        message: "提交成功！"
      });
      this.$store.dispatch("coupon/getCouponInfo");
    }
    error &&
      (this as any).$toast({
        type: "fail",
        message: error.msg
      });
  }
  /**
   * 显示 驳回/确认 弹出层
   */
  showProup(type: any) {
    type == 0 ? (this.showRejectProup = true) : (this.showConfirmProup = true);
    this.message = "";
  }
  /**
   * 券状态 样式
   */
  renderStatusStyle(status: number) {
    switch (status) {
      case 30:
        return "#09BB07";
        break;
      case 10:
        return "#9B9B9B";
        break;
      case 20:
        return "#F92E93";
        break;
      default:
        return "#F76260";
        break;
    }
  }
}
